import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_DELETE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';
import FieldType from '@app/store/FieldType';

type EditingDocumentSignatureFieldsIdsState = string[];

const initialState: EditingDocumentSignatureFieldsIdsState = [];

export default function reducer(
  state: EditingDocumentSignatureFieldsIdsState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { fieldType } = action.payload.information;
        const { uuid } = action.payload.meta;
        if (fieldType === FieldType.SIGNATURE_FIELD) {
          draft.push(uuid);
        }
      });
    case EDITING_DOCUMENT__FIELD_DELETE: {
      const { uuid } = action.payload;
      return state.filter((id) => id !== uuid);
    }
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
